import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { reverseArrowIconDirectionForRtl } from '@application/Interfaces/Icons/utils'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

import { SVG } from './ArrowIcon.styled'

export const ArrowIcon: IconComponent = ({
    className,
    colorCode = 'white',
    width = 11,
    height = 6,
    direction = 'down',
    onClick,
}) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    const directionTransformed = reverseArrowIconDirectionForRtl({
        iconDirection: direction,
        themeDirection: theme.direction,
    })

    return (
        <SVG
            className={className}
            width={width}
            height={height}
            direction={directionTransformed}
            onClick={onClick}
            viewBox="0 0 11 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.75544 0.130886C0.582512 -0.0436287 0.302527 -0.0436287 0.1296 0.130886C-0.0430727 0.305139 -0.0433283 0.58817 0.1296 0.762684L5.18697 5.86911C5.3599 6.04363 5.64014 6.04363 5.81306 5.86911L10.8703 0.762815C11.0432 0.5883 11.0432 0.305531 10.8703 0.131016C10.6974 -0.043498 10.4173 -0.043498 10.2445 0.130625L5.49995 4.78773L0.75544 0.130886Z"
                fill={color}
            />
        </SVG>
    )
}
